import { configureStore } from "@reduxjs/toolkit";
import SearchReducer from "../website/search/SearchSlice";
import fileReducer from "../admin/fileManagerSlice";
import hotelFilterReducer from "../website/search/hotelFliterSlice";
import bookedReducer from "../website/booking/BookingSlice";
import duplicateHotelReducer from "../admin/dupHotelSlice";

export const store = configureStore({
  reducer: {
    search: SearchReducer,
    file: fileReducer,
    hotelFilter: hotelFilterReducer,
    booked: bookedReducer,
    duplicateHotel: duplicateHotelReducer,
  },
  devTools: true,
});
